import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import NumberFormat from "react-number-format";
import {
  getFirestore,
  collection,
  addDoc,
} from "firebase/firestore";
import { initializeApp } from "firebase/app";

import "../App.css";

const Enviar = (props) => {
  const [datos_retiro, set_datos_retiro] = useState("Datos de despacho");
  const [loading, set_loading] = useState(1);
  const [region, set_region] = useState("XIII");
  const [comuna_aux, set_comuna_aux] = useState("");
  const [option1, set_option1] = useState(true);
  const [option2, set_option2] = useState(false);
  const history = useHistory();
  const [iva, set_iva] = useState(
    props.persona ? 0 : Math.round(props.price_total * 0.19)
  );

  const [warning, warning_change] = useState("Continuar");
  const [buttonHandler_retiro, buttonHandler_retiro_update] = useState([
    { backgroundColor: "#faa916" },
    { backgroundColor: "rgb(255, 255, 255)" },
  ]);
  const [buttonHandler, buttonHandler_update] = useState([
    { backgroundColor: "rgb(255, 255, 255)" },
    { backgroundColor: "#faa916" },
    "",
  ]);

  initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_API_ID,
  });

  let html_productos = "";

  props.products.map((item) => {
    if (item.n > 0) {
      html_productos =
        html_productos +
        "<p style='margin: 10px auto;'><b>" +
        Number(item.n).toLocaleString() +
        "x </b>" +
        item.name +
        ":<b> $" +
        Number(
          item.n * Math.round((item.price * (1 - item.off / 100)) / 10) * 10
        ).toLocaleString() +
        "</b></p>";
    }
    return "";
  });

  const press_retiro = (a) => {
    if (a === 1) {
      buttonHandler_retiro_update([
        { backgroundColor: "#faa916" },
        { backgroundColor: "rgb(255, 255, 255)" },
      ]);
      set_option1(true);
      props.delivery_por_comuna(2490);
      set_datos_retiro("Datos de despacho");
    } else {
      buttonHandler_retiro_update([
        { backgroundColor: "rgb(255, 255, 255)" },
        { backgroundColor: "#faa916" },
      ]);
      set_option1(false);
      props.delivery_por_comuna(0);
      set_datos_retiro("Retiro en Av el Cerro 1731, Providencia.");
    }
  };

  const press_pago = (a) => {
    if (a === 1) {
      buttonHandler_update([
        { backgroundColor: "#faa916" },
        { backgroundColor: "rgb(255, 255, 255)" },
        "",
      ]);
      set_option2(true);
    } else {
      buttonHandler_update([
        { backgroundColor: "rgb(255, 255, 255)" },
        { backgroundColor: "#faa916" },
        "Te llegará un correo con los datos de depósito!",
      ]);
      set_option2(false);
    }
  };

  function validateEmail(email) {
    const re =
      /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const send = (e) => {
    e.preventDefault();

    if (e.target.nombre.value === "") {
      warning_change("Y tu Nombre?");
    } else if (e.target.mail1.value === "") {
      warning_change("Y tu Mail?");
    } else if (e.target.celular.value === "") {
      warning_change("Y tu Celular?");
    } else if (e.target.direccion.value === "" && option1) {
      warning_change("Y tu dirección?");
    } else if (!comuna_aux && option1) {
      warning_change("Y tu comuna?");
    } else {
      warning_change("Continuar");
      set_loading(0.3);
      save_data(e.target);
    }
  };
  
  const save_data = (e) => {
    const ventu_user = {
      nombre: e.nombre.value,
      mail: e.mail1.value,
      celular: e.celular.value,
      direccion: e.direccion.value,
      otros: e.otros.value,
      comuna: comuna_aux,
      domicilio: option1,
      tarjeta: option2,
      price_total: parseInt(props.price_total + props.delivery + iva),
      delivery_price: props.delivery,
      rut: e.rut.value,
      iva: props.persona ? "" : "IVA: $" + iva,
    };
    localStorage.setItem("ventu_user", JSON.stringify(ventu_user));
    localStorage.setItem("ventu_products", JSON.stringify(props.products));
    localStorage.setItem("ventu_store", JSON.stringify(props.store));

    let products = [];
    props.products.map((item) => {
      if (item.n > 0) {
        products.push({
          product: item.name,
          n: item.n,
        });
      }
    });

    addDoc(
      collection(getFirestore(), "ventas"),
      {
        name: e.nombre.value,
        mail: e.mail1.value,
        phone: e.celular.value,
        address: e.direccion.value,
        otros: e.otros.value,
        comuna: comuna_aux,
        modo_despacho: option1,
        modo_tarjeta: option2,
        modo_payment: 2,
        products_price: props.price_total,
        delivery_price: props.delivery,
        rut: e.rut.value,
        iva: props.persona ? 0 : iva,
        products: products,
        date: Date.now(),
        store_id: "cornerdog",
        store_name: "Cornerdog",
        store_mail: "hola@cornerdog.cl",
        store_bank_bank: "Banco Estado",
        store_bank_number: "18396969",
        store_bank_rut: "18.396.969-2",
        store_bank_type: "Cuenta Vista",
        payed: false,
        token_ws: Date.now().toString(),
      }
    )
      .then(() => {
        if (option2) {
          window.location.assign(
            "https://us-central1-levanta-tu-pyme.cloudfunctions.net/pay_cornerdog?a=" +
              parseInt(props.price_total + props.delivery + iva),
            "_blank"
          );
        } else {
          history.push("/checkout");
        }
        console.log("okey");
      })
      .catch((err) => {
        console.log(err);
        alert("Error al enviar el pedido. Inténtalo denuevo o escríbenos.");
      });
  };

  const aa = (e) => {
    set_region(e.target.value);
    e.target.value !== "XIII"
      ? props.delivery_por_comuna(0)
      : props.delivery_por_comuna(2490);
  };

  const bb = (e) => {
    if (region !== "XIII") {
      props.delivery_por_comuna(0);
    } else if (
      e.target.value === "Maipú" ||
      e.target.value === "San Bernardo" ||
      e.target.value === "Quilicura" ||
      e.target.value === "Pudahuel" ||
      e.target.value === "El Bosque" ||
      e.target.value === "Colina" ||
      e.target.value === "Puente Alto"
    ) {
      props.delivery_por_comuna(3990);
    } else if (
      e.target.value === "Estación Central" ||
      e.target.value === "Cerrillos" ||
      e.target.value === "San Ramón" ||
      e.target.value === "San Joaquín" ||
      e.target.value === "Pedro Aguirre Cerda" ||
      e.target.value === "Lo Espejo" ||
      e.target.value === "La Granja" ||
      e.target.value === "Conchalí" ||
      e.target.value === "Quinta Normal" ||
      e.target.value === "Cerro Navia" ||
      e.target.value === "San Miguel" ||
      e.target.value === "Macul" ||
      e.target.value === "Lo Prado"
    ) {
      props.delivery_por_comuna(2990);
    } else if (
      e.target.value === "Isla de Maipo" ||
      e.target.value === "Peñaflor" ||
      e.target.value === "Talagante" ||
      e.target.value === "El Monte" ||
      e.target.value === "Calera de Tango" ||
      e.target.value === "Pirque" ||
      e.target.value === "Paine" ||
      e.target.value === "Buin" ||
      e.target.value === "Melipilla" ||
      e.target.value === "Padre Hurtado"
    ) {
      props.delivery_por_comuna(4590);
    } else {
      props.delivery_por_comuna(2490);
    }
    set_comuna_aux(e.target.value);
  };

  return (
    <form className="enviar" onSubmit={send}>
      <img src="/img/logo_footer2.png" alt=""></img>

      <div className="spot">
        <p className="o">{datos_retiro}</p>

        <div className="pago_css">
          <div
            style={buttonHandler_retiro[0]}
            className="button1"
            onClick={press_retiro.bind(this, 1)}
          >
            A Domicilio
          </div>
          <div
            style={buttonHandler_retiro[1]}
            className="button2"
            onClick={press_retiro.bind(this, 2)}
          >
            Retiro (Providencia)
          </div>
        </div>

        <div className="lista_final">
          <input name="nombre" type="text" placeholder="Nombre" />
          <input name="mail1" type="email" placeholder="Email" />
          <input name="celular" type="number" placeholder="Teléfono" />

          <div
            style={{
              display: option1 ? "block" : "none",
            }}
          >
            <select name="region" onChange={aa}>
              <option value="XIII">Región Metropolitana</option>
              <option value="I">I Región de Tarapacá</option>
              <option value="II">II Región de Antofagasta</option>
              <option value="III">III Región de Atacama</option>
              <option value="IV">IV Región de Coquimbo</option>
              <option value="V">V Región de Valparaíso</option>
              <option value="VI">
                VI Región del Libertador General Bernardo O’Higgins
              </option>
              <option value="VII">VII Región del Maule</option>
              <option value="VIII">VIII Región del Biobío</option>
              <option value="IX">IX Región de la Araucanía</option>
              <option value="X">X Región de Los Lagos</option>
              <option value="XI">
                XI Región Aysén del General Carlos Ibáñez del Campo
              </option>
              <option value="XII">
                XII Región de Magallanes y de la Antártica Chilena
              </option>
              <option value="XIV">XIV Región de Los Ríos</option>
              <option value="XV">XV Región de Arica y Parinacota</option>
              <option value="XVI">XVI Región de Ñuble</option>
            </select>

            <select
              name="I"
              style={{ display: region === "I" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Alto Hospicio">Alto Hospicio</option>
              <option value="Camiña">Camiña</option>
              <option value="Colchane">Colchane</option>
              <option value="Huara">Huara</option>
              <option value="Iquique">Iquique</option>
              <option value="Pica">Pica</option>
              <option value="Pozo Almonte">Pozo Almonte</option>
            </select>
            <select
              name="II"
              style={{ display: region === "II" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Antofagasta">Antofagasta</option>
              <option value="Calama">Calama</option>
              <option value="María Elena">María Elena</option>
              <option value="Mejillones">Mejillones</option>
              <option value="Ollagüe">Ollagüe</option>
              <option value="San Pedro de Atacama">San Pedro de Atacama</option>
              <option value="Sierra Gorda">Sierra Gorda</option>
              <option value="Taltal">Taltal</option>
              <option value="Tocopilla">Tocopilla</option>
            </select>
            <select
              name="III"
              style={{ display: region === "III" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Alto del Carmen">Alto del Carmen</option>
              <option value="Caldera">Caldera</option>
              <option value="Chañaral">Chañaral</option>
              <option value="Copiapó">Copiapó</option>
              <option value="Diego de Almagro">Diego de Almagro</option>
              <option value="Freirina">Freirina</option>
              <option value="Huasco">Huasco</option>
              <option value="Tierra Amarilla">Tierra Amarilla</option>
              <option value="Vallenar">Vallenar</option>
            </select>
            <select
              name="IV"
              style={{ display: region === "IV" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Andacollo">Andacollo</option>
              <option value="Canela">Canela</option>
              <option value="Combarbalá">Combarbalá</option>
              <option value="Coquimbo">Coquimbo</option>
              <option value="Illapel">Illapel</option>
              <option value="La Higuera">La Higuera</option>
              <option value="La Serena">La Serena</option>
              <option value="Los Vilos">Los Vilos</option>
              <option value="Monte Patria">Monte Patria</option>
              <option value="Ovalle">Ovalle</option>
              <option value="Paihuano">Paihuano</option>
              <option value="Punitaqui">Punitaqui</option>
              <option value="Río Hurtado">Río Hurtado</option>
              <option value="Salamanca">Salamanca</option>
              <option value="Vicuña">Vicuña</option>
            </select>
            <select
              name="IX"
              style={{ display: region === "IX" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Angol">Angol</option>
              <option value="Carahue">Carahue</option>
              <option value="Chol Chol">Chol Chol</option>
              <option value="Collipulli">Collipulli</option>
              <option value="Cunco">Cunco</option>
              <option value="Curacautín">Curacautín</option>
              <option value="Curarrehue">Curarrehue</option>
              <option value="Ercilla">Ercilla</option>
              <option value="Freire">Freire</option>
              <option value="Galvarino">Galvarino</option>
              <option value="Gorbea">Gorbea</option>
              <option value="Lautaro">Lautaro</option>
              <option value="Loncoche">Loncoche</option>
              <option value="Lonquimay">Lonquimay</option>
              <option value="Los Sauces">Los Sauces</option>
              <option value="Lumaco">Lumaco</option>
              <option value="Melipeuco">Melipeuco</option>
              <option value="Nueva Imperial">Nueva Imperial</option>
              <option value="Padre Las Casas">Padre Las Casas</option>
              <option value="Perquenco">Perquenco</option>
              <option value="Pitrufquén">Pitrufquén</option>
              <option value="Pucón">Pucón</option>
              <option value="Purén">Purén</option>
              <option value="Renaico">Renaico</option>
              <option value="Saavedra">Saavedra</option>
              <option value="Temuco">Temuco</option>
              <option value="Teodoro Schmidt">Teodoro Schmidt</option>
              <option value="Toltén">Toltén</option>
              <option value="Traiguén">Traiguén</option>
              <option value="Victoria">Victoria</option>
              <option value="Vilcún">Vilcún</option>
              <option value="Villarrica">Villarrica</option>
            </select>
            <select
              name="XIII"
              style={{ display: region === "XIII" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Alhué">Alhué</option>
              <option value="Buin">Buin</option>
              <option value="Calera de Tango">Calera de Tango</option>
              <option value="Cerrillos">Cerrillos</option>
              <option value="Cerro Navia">Cerro Navia</option>
              <option value="Colina">Colina</option>
              <option value="Conchalí">Conchalí</option>
              <option value="Curacaví">Curacaví</option>
              <option value="El Bosque">El Bosque</option>
              <option value="El Monte">El Monte</option>
              <option value="Estación Central">Estación Central</option>
              <option value="Huechuraba">Huechuraba</option>
              <option value="Independencia">Independencia</option>
              <option value="Isla de Maipo">Isla de Maipo</option>
              <option value="La Cisterna">La Cisterna</option>
              <option value="La Florida">La Florida</option>
              <option value="La Granja">La Granja</option>
              <option value="La Pintana">La Pintana</option>
              <option value="La Reina">La Reina</option>
              <option value="Lampa">Lampa</option>
              <option value="Las Condes">Las Condes</option>
              <option value="Lo Barnechea">Lo Barnechea</option>
              <option value="Lo Espejo">Lo Espejo</option>
              <option value="Lo Prado">Lo Prado</option>
              <option value="Macul">Macul</option>
              <option value="Maipú">Maipú</option>
              <option value="María Pinto">María Pinto</option>
              <option value="Melipilla">Melipilla</option>
              <option value="Ñuñoa">Ñuñoa</option>
              <option value="Padre Hurtado">Padre Hurtado</option>
              <option value="Paine">Paine</option>
              <option value="Pedro Aguirre Cerda">Pedro Aguirre Cerda</option>
              <option value="Peñaflor">Peñaflor</option>
              <option value="Peñalolén">Peñalolén</option>
              <option value="Pirque">Pirque</option>
              <option value="Providencia">Providencia</option>
              <option value="Pudahuel">Pudahuel</option>
              <option value="Puente Alto">Puente Alto</option>
              <option value="Quilicura">Quilicura</option>
              <option value="Quinta Normal">Quinta Normal</option>
              <option value="Recoleta">Recoleta</option>
              <option value="Renca">Renca</option>
              <option value="San Bernardo">San Bernardo</option>
              <option value="San Joaquín">San Joaquín</option>
              <option value="San Miguel">San Miguel</option>
              <option value="San Pedro">San Pedro</option>
              <option value="San Ramón">San Ramón</option>
              <option value="Santiago">Santiago</option>
              <option value="Talagante">Talagante</option>
              <option value="Til Til">Til Til</option>
              <option value="Vitacura">Vitacura</option>
            </select>
            <select
              name="V"
              style={{ display: region === "V" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Algarrobo">Algarrobo</option>
              <option value="Cabildo">Cabildo</option>
              <option value="Calle Larga">Calle Larga</option>
              <option value="Cartagena">Cartagena</option>
              <option value="Casablanca">Casablanca</option>
              <option value="Catemu">Catemu</option>
              <option value="Concón">Concón</option>
              <option value="El Quisco">El Quisco</option>
              <option value="El Tabo">El Tabo</option>
              <option value="Hijuelas">Hijuelas</option>
              <option value="Isla de Pascua">Isla de Pascua</option>
              <option value="Juan Fernández">Juan Fernández</option>
              <option value="La Calera">La Calera</option>
              <option value="La Cruz">La Cruz</option>
              <option value="La Ligua">La Ligua</option>
              <option value="Limache">Limache</option>
              <option value="Llay Llay">Llay Llay</option>
              <option value="Los Andes">Los Andes</option>
              <option value="Nogales">Nogales</option>
              <option value="Olmué">Olmué</option>
              <option value="Panquehue">Panquehue</option>
              <option value="Papudo">Papudo</option>
              <option value="Petorca">Petorca</option>
              <option value="Puchuncaví">Puchuncaví</option>
              <option value="Putaendo">Putaendo</option>
              <option value="Quillota">Quillota</option>
              <option value="Quilpué">Quilpué</option>
              <option value="Quintero">Quintero</option>
              <option value="Rinconada">Rinconada</option>
              <option value="San Antonio">San Antonio</option>
              <option value="San Esteban">San Esteban</option>
              <option value="San Felipe">San Felipe</option>
              <option value="Santa María">Santa María</option>
              <option value="Santo Domingo">Santo Domingo</option>
              <option value="Valparaíso">Valparaíso</option>
              <option value="Villa Alemana">Villa Alemana</option>
              <option value="Viña del Mar">Viña del Mar</option>
              <option value="Zapallar">Zapallar</option>
            </select>
            <select
              name="VI"
              style={{ display: region === "VI" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Chépica">Chépica</option>
              <option value="Chimbarongo">Chimbarongo</option>
              <option value="Codegua">Codegua</option>
              <option value="Coinco">Coinco</option>
              <option value="Coltauco">Coltauco</option>
              <option value="Doñihue">Doñihue</option>
              <option value="Graneros">Graneros</option>
              <option value="La Estrella">La Estrella</option>
              <option value="Las Cabras">Las Cabras</option>
              <option value="Litueche">Litueche</option>
              <option value="Lolol">Lolol</option>
              <option value="Machalí">Machalí</option>
              <option value="Malloa">Malloa</option>
              <option value="Marchigüe">Marchigüe</option>
              <option value="Mostazal">Mostazal</option>
              <option value="Nancagua">Nancagua</option>
              <option value="Navidad">Navidad</option>
              <option value="Olivar">Olivar</option>
              <option value="Palmilla">Palmilla</option>
              <option value="Paredones">Paredones</option>
              <option value="Peralillo">Peralillo</option>
              <option value="Peumo">Peumo</option>
              <option value="Pichidegua">Pichidegua</option>
              <option value="Pichilemu">Pichilemu</option>
              <option value="Placilla">Placilla</option>
              <option value="Pumanque">Pumanque</option>
              <option value="Quinta de Tilcoco">Quinta de Tilcoco</option>
              <option value="Rancagua">Rancagua</option>
              <option value="Rengo">Rengo</option>
              <option value="Requínoa">Requínoa</option>
              <option value="San Fernando">San Fernando</option>
              <option value="San Vicente de Tagua Tagua">
                San Vicente de Tagua Tagua
              </option>
              <option value="Santa Cruz">Santa Cruz</option>
            </select>
            <select
              name="VII"
              style={{ display: region === "VII" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Cauquenes">Cauquenes</option>
              <option value="Chanco">Chanco</option>
              <option value="Colbún">Colbún</option>
              <option value="Constitución">Constitución</option>
              <option value="Curepto">Curepto</option>
              <option value="Curicó">Curicó</option>
              <option value="Empedrado">Empedrado</option>
              <option value="Hualañé">Hualañé</option>
              <option value="Licantén">Licantén</option>
              <option value="Linares">Linares</option>
              <option value="Longaví">Longaví</option>
              <option value="Maule">Maule</option>
              <option value="Molina">Molina</option>
              <option value="Parral">Parral</option>
              <option value="Pelarco">Pelarco</option>
              <option value="Pelluhue">Pelluhue</option>
              <option value="Pencahue">Pencahue</option>
              <option value="Rauco">Rauco</option>
              <option value="Retiro">Retiro</option>
              <option value="Río Claro">Río Claro</option>
              <option value="Romeral">Romeral</option>
              <option value="Sagrada Familia">Sagrada Familia</option>
              <option value="San Clemente">San Clemente</option>
              <option value="San Javier">San Javier</option>
              <option value="San Rafael">San Rafael</option>
              <option value="Talca">Talca</option>
              <option value="Teno">Teno</option>
              <option value="Vichuquén">Vichuquén</option>
              <option value="Villa Alegre">Villa Alegre</option>
              <option value="Yerbas Buenas">Yerbas Buenas</option>
            </select>
            <select
              name="VIII"
              style={{ display: region === "VIII" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Alto Bío Bío">Alto Bío Bío</option>
              <option value="Antuco">Antuco</option>
              <option value="Arauco">Arauco</option>
              <option value="Cabrero">Cabrero</option>
              <option value="Cañete">Cañete</option>
              <option value="Chiguayante">Chiguayante</option>
              <option value="Concepción">Concepción</option>
              <option value="Contulmo">Contulmo</option>
              <option value="Coronel">Coronel</option>
              <option value="Curanilahue">Curanilahue</option>
              <option value="Florida">Florida</option>
              <option value="Hualpén">Hualpén</option>
              <option value="Hualqui">Hualqui</option>
              <option value="Laja">Laja</option>
              <option value="Lebu">Lebu</option>
              <option value="Los Álamos">Los Álamos</option>
              <option value="Los Ángeles">Los Ángeles</option>
              <option value="Lota">Lota</option>
              <option value="Mulchén">Mulchén</option>
              <option value="Nacimiento">Nacimiento</option>
              <option value="Negrete">Negrete</option>
              <option value="Penco">Penco</option>
              <option value="Quilaco">Quilaco</option>
              <option value="Quilleco">Quilleco</option>
              <option value="San Pedro de la Paz">San Pedro de la Paz</option>
              <option value="San Rosendo">San Rosendo</option>
              <option value="Santa Bárbara">Santa Bárbara</option>
              <option value="Santa Juana">Santa Juana</option>
              <option value="Talcahuano">Talcahuano</option>
              <option value="Tirúa">Tirúa</option>
              <option value="Tomé">Tomé</option>
              <option value="Tucapel">Tucapel</option>
              <option value="Yumbel">Yumbel</option>
            </select>
            <select
              name="X"
              style={{ display: region === "X" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Ancud">Ancud</option>
              <option value="Calbuco">Calbuco</option>
              <option value="Castro">Castro</option>
              <option value="Chaitén">Chaitén</option>
              <option value="Chonchi">Chonchi</option>
              <option value="Cochamó">Cochamó</option>
              <option value="Curaco de Vélez">Curaco de Vélez</option>
              <option value="Dalcahue">Dalcahue</option>
              <option value="Fresia">Fresia</option>
              <option value="Frutillar">Frutillar</option>
              <option value="Futaleufú">Futaleufú</option>
              <option value="Hualaihué">Hualaihué</option>
              <option value="Llanquihue">Llanquihue</option>
              <option value="Los Muermos">Los Muermos</option>
              <option value="Maullín">Maullín</option>
              <option value="Osorno">Osorno</option>
              <option value="Palena">Palena</option>
              <option value="Puerto Montt">Puerto Montt</option>
              <option value="Puerto Octay">Puerto Octay</option>
              <option value="Puerto Varas">Puerto Varas</option>
              <option value="Puqueldón">Puqueldón</option>
              <option value="Purranque">Purranque</option>
              <option value="Puyehue">Puyehue</option>
              <option value="Queilén">Queilén</option>
              <option value="Quellón">Quellón</option>
              <option value="Quemchi">Quemchi</option>
              <option value="Quinchao">Quinchao</option>
              <option value="Río Negro">Río Negro</option>
              <option value="San Juan de la Costa">San Juan de la Costa</option>
              <option value="San Pablo">San Pablo</option>
            </select>
            <select
              name="XI"
              style={{ display: region === "XI" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Aysén">Aysén</option>
              <option value="Chile Chico">Chile Chico</option>
              <option value="Cisnes">Cisnes</option>
              <option value="Cochrane">Cochrane</option>
              <option value="Coyhaique">Coyhaique</option>
              <option value="Guaitecas">Guaitecas</option>
              <option value="Lago Verde">Lago Verde</option>
              <option value="O’Higgins">O’Higgins</option>
              <option value="Río Ibáñez">Río Ibáñez</option>
              <option value="Tortel">Tortel</option>
            </select>
            <select
              name="XII"
              style={{ display: region === "XII" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Antártica">Antártica</option>
              <option value="Cabo de Hornos">Cabo de Hornos</option>
              <option value="Laguna Blanca">Laguna Blanca</option>
              <option value="Porvenir">Porvenir</option>
              <option value="Primavera">Primavera</option>
              <option value="Puerto Natales">Puerto Natales</option>
              <option value="Punta Arenas">Punta Arenas</option>
              <option value="Río Verde">Río Verde</option>
              <option value="San Gregorio">San Gregorio</option>
              <option value="Timaukel">Timaukel</option>
              <option value="Torres del Paine">Torres del Paine</option>
            </select>
            <select
              name="XIV"
              style={{ display: region === "XIV" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Corral">Corral</option>
              <option value="Futrono">Futrono</option>
              <option value="La Unión">La Unión</option>
              <option value="Lago Ranco">Lago Ranco</option>
              <option value="Lanco">Lanco</option>
              <option value="Los Lagos">Los Lagos</option>
              <option value="Máfil">Máfil</option>
              <option value="Mariquina">Mariquina</option>
              <option value="Paillaco">Paillaco</option>
              <option value="Panguipulli">Panguipulli</option>
              <option value="Río Bueno">Río Bueno</option>
              <option value="Valdivia">Valdivia</option>
            </select>
            <select
              name="XV"
              style={{ display: region === "XV" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Arica">Arica</option>
              <option value="Camarones">Camarones</option>
              <option value="General Lagos">General Lagos</option>
              <option value="Putre">Putre</option>
            </select>
            <select
              name="XVI"
              style={{ display: region === "XVI" ? "block" : "none" }}
              onChange={bb}
            >
              <option value="Comuna">Comuna</option>
              <option value="Bulnes">Bulnes</option>
              <option value="Chillán">Chillán</option>
              <option value="Chillán Viejo">Chillán Viejo</option>
              <option value="Cobquecura">Cobquecura</option>
              <option value="Coelemu">Coelemu</option>
              <option value="Coihueco">Coihueco</option>
              <option value="El Carmen">El Carmen</option>
              <option value="Ninhue">Ninhue</option>
              <option value="Ñiquén">Ñiquén</option>
              <option value="Pemuco">Pemuco</option>
              <option value="Pinto">Pinto</option>
              <option value="Portezuelo">Portezuelo</option>
              <option value="Quillón">Quillón</option>
              <option value="Quirihue">Quirihue</option>
              <option value="Ránquil">Ránquil</option>
              <option value="San Carlos">San Carlos</option>
              <option value="San Fabián">San Fabián</option>
              <option value="San Ignacio">San Ignacio</option>
              <option value="San Nicolás">San Nicolás</option>
              <option value="Trehuaco">Trehuaco</option>
              <option value="Yungay">Yungay</option>
            </select>
            <div className="sub_enviar_dpto">
              <input
                name="direccion"
                type="text"
                placeholder="Dirección"
                className="uno"
              />
              <input
                name="otros"
                type="text"
                placeholder="Dpto"
                className="dos"
              />
            </div>
            <input
              name="rut"
              type="text"
              placeholder="Rut"
              style={{ display: region === "XIII" ? "none" : "block" }}
            />
          </div>
          <h1
            className="aviso"
            style={{
              display: region === "XIII" ? "none" : "block",
            }}
          >
            Envíos a domicilio vía Starken <b>por pagar</b>. Si quieres retiro
            en sucursal, anota la dirección de ésta.
          </h1>
        </div>
      </div>

      <div className="spot">
        <p className="o">Tu pedido</p>
        <img
          src="/img/edit.svg"
          className="edit_button"
          alt=" "
          onClick={props.atras}
        ></img>
        <div className="lista_final">
          {props.products.map((item) => {
            if (item.n > 0) {
              return (
                <div key={item.name} style={{ margin: "15px 0px" }}>
                  <p>
                    {item.n}x {item.name}
                  </p>{" "}
                  <p>
                    <NumberFormat
                      value={item.n * item.price}
                      displayType={"text"}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      prefix={"$ "}
                      className="details"
                    />
                  </p>
                </div>
              );
            }
            return "";
          })}
        </div>
      </div>

      <div className="spot">
        <p className="o">Resumen</p>
        <img
          src="/img/edit.svg"
          className="edit_button"
          alt=" "
          onClick={props.atras}
        ></img>
        <div className="lista_final">
          <p>
            Snacks:
            {"   "}
            {
              <NumberFormat
                value={props.price_total}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
                prefix={"$ "}
                className="details"
              />
            }
          </p>
          <p style={{ display: props.persona ? "none" : "block" }}>
            IVA:
            {"   "}
            {
              <NumberFormat
                value={iva}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
                prefix={"$ "}
                className="details"
              />
            }
          </p>
          <p>
            Despacho:
            {"   "}
            {region === "XIII" ? (
              <NumberFormat
                value={props.delivery}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
                prefix={"$ "}
                className="details"
              />
            ) : (
              "Starken por pagar"
            )}
          </p>
          <p>
            <b>
              Total:
              {"   "}
              {
                <NumberFormat
                  value={props.total + iva}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  prefix={"$ "}
                  className="details"
                />
              }
            </b>
          </p>
        </div>
        <div className="pago_css">
          <div
            style={buttonHandler[1]}
            className="button2"
            // onClick={press_pago.bind(this, 2)}
          >
            Transferencia
          </div>
        </div>
      </div>
      <h1 className="aviso">{buttonHandler[2]}</h1>
      <input name="mensaje" className="html_submit" value="" readOnly />
      <div className="pago_css">
        <button
          className="boton_submit"
          style={{ backgroundColor: "#ba2d0b" }}
          onClick={props.atras}
        >
          Cancelar
        </button>
        <input
          className="boton_submit"
          type="submit"
          value={warning}
          style={{ opacity: loading }}
        />
      </div>
    </form>
  );
};

export default Enviar;
